/**
 * Admin Chat Hub — Painel de administração do Chat Hub
 * Fase 1: Dashboard, Conversas, Configurações (funcionais)
 * Abas restantes: placeholder "Em desenvolvimento"
 */

import { useState, useEffect } from 'preact/hooks';
import { api } from '../api/client';
import { Button, Input, Select, SkeletonBar, TableSkeleton, PageShell, Textarea } from '../components/ui';
import { T } from '../styles/tokens';

// ── Ícones SVG inline ──
const Icons = {
  dashboard: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="7" height="7" rx="1.5"/><rect x="14" y="3" width="7" height="7" rx="1.5"/><rect x="3" y="14" width="7" height="7" rx="1.5"/><rect x="14" y="14" width="7" height="7" rx="1.5"/></svg>,
  chat: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/></svg>,
  users: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/></svg>,
  settings: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-4 0v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83-2.83l.06-.06A1.65 1.65 0 004.68 15a1.65 1.65 0 00-1.51-1H3a2 2 0 010-4h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 012.83-2.83l.06.06A1.65 1.65 0 009 4.68a1.65 1.65 0 001-1.51V3a2 2 0 014 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 2.83l-.06.06A1.65 1.65 0 0019.4 9a1.65 1.65 0 001.51 1H21a2 2 0 010 4h-.09a1.65 1.65 0 00-1.51 1z"/></svg>,
  shield: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>,
  chart: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 20V10"/><path d="M12 20V4"/><path d="M6 20v-6"/></svg>,
  trash: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 6h18"/><path d="M8 6V4a2 2 0 012-2h4a2 2 0 012 2v2"/><path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6"/></svg>,
  coins: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="8" cy="8" r="6"/><path d="M18.09 10.37A6 6 0 1110.34 18"/><line x1="7" y1="6" x2="7.01" y2="6"/><line x1="16" y1="12" x2="16.01" y2="12"/></svg>,
  check: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>,
  x: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>,
  chevronLeft: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6"/></svg>,
  chevronRight: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"/></svg>,
  search: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>,
};

const TABS = [
  { id: 'dashboard', label: 'Dashboard', icon: Icons.dashboard },
  { id: 'conversations', label: 'Conversas', icon: Icons.chat },
  { id: 'users', label: 'Usuários', icon: Icons.users },
  { id: 'config', label: 'Configurações', icon: Icons.settings },
  { id: 'compliance', label: 'Compliance', icon: Icons.shield },
  { id: 'analytics', label: 'Analytics', icon: Icons.chart },
  { id: 'cleanup', label: 'Limpeza', icon: Icons.trash },
  { id: 'tokens', label: 'Tokens', icon: Icons.coins },
] as const;

// ── Categorias de config ──
const CONFIG_CATEGORIES: Record<string, { label: string; keys: string[] }> = {
  limits: {
    label: 'Limites',
    keys: ['max_tokens_output', 'max_input_length', 'max_conversations_per_user', 'max_messages_per_conversation', 'rate_limit_rpm', 'max_history_messages', 'min_balance_to_chat'],
  },
  models: {
    label: 'Modelos',
    keys: ['default_model', 'allowed_models', 'blocked_models'],
  },
  features: {
    label: 'Features',
    keys: ['enable_streaming', 'enable_attachments', 'enable_tts', 'enable_compliance_scan', 'system_prompt_global'],
  },
  cleanup: {
    label: 'Limpeza',
    keys: ['auto_archive_days', 'hard_delete_archived_days'],
  },
};

// ── Estilos ──
const s = {
  page: { padding: '24px 32px', maxWidth: 1400, margin: '0 auto' } as any,
  title: { fontSize: 24, fontWeight: 700, color: T.text, marginBottom: 24 } as any,
  card: { background: T.bgCard, border: `1px solid ${T.border}`, borderRadius: 12, padding: 20 } as any,
  tabBar: { display: 'flex', gap: 0, borderBottom: `1px solid ${T.bgHover}`, marginBottom: 24, overflowX: 'auto' as any } as any,
  tab: (active: boolean) => ({
    padding: '10px 16px', cursor: 'pointer', fontSize: 13, fontWeight: active ? 600 : 500,
    color: active ? T.primary : T.textSecondary, borderBottom: active ? `2px solid ${T.primary}` : '2px solid transparent',
    display: 'flex', alignItems: 'center', gap: 6, whiteSpace: 'nowrap' as any, transition: 'all 0.15s',
    flexShrink: 0,
  }),
  input: { width: '100%', padding: '8px 12px', borderRadius: 8, fontSize: 14, background: T.bgCardHover, border: `1px solid ${T.borderHover}`, color: T.text, outline: 'none', boxSizing: 'border-box' as any } as any,
  textarea: { width: '100%', padding: '8px 12px', borderRadius: 8, fontSize: 13, background: T.bgCardHover, border: `1px solid ${T.borderHover}`, color: T.text, outline: 'none', minHeight: 80, resize: 'vertical' as any, fontFamily: 'monospace', boxSizing: 'border-box' as any } as any,
  btn: (variant: 'primary' | 'danger' | 'ghost') => ({
    padding: '8px 16px', borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: 'pointer', border: 'none',
    display: 'inline-flex', alignItems: 'center', gap: 6, transition: 'all 0.15s',
    ...(variant === 'primary' ? { background: T.primary, color: T.text } :
       variant === 'danger' ? { background: T.danger, color: T.text } :
       { background: T.border, color: T.textSecondary }),
  }),
  metricCard: { ...{ background: T.bgCard, border: `1px solid ${T.border}`, borderRadius: 12, padding: '20px 24px' } } as any,
  table: { width: '100%', borderCollapse: 'collapse' as any, fontSize: 13 } as any,
  th: { textAlign: 'left' as any, padding: '10px 12px', color: T.textSecondary, fontWeight: 600, fontSize: 11, textTransform: 'uppercase' as any, letterSpacing: '0.5px', borderBottom: `1px solid ${T.border}` } as any,
  td: { padding: '12px 12px', color: T.text, borderBottom: `1px solid ${T.bgCard}` } as any,
  placeholder: { textAlign: 'center' as any, padding: '80px 20px', color: T.textMuted } as any,
};

// ── Toggle component ──
function Toggle({ checked, onChange }: { checked: boolean; onChange: (v: boolean) => void }) {
  return (
    <div onClick={() => onChange(!checked)} style={{
      width: 40, height: 22, borderRadius: 11, cursor: 'pointer', transition: 'background 0.2s',
      background: checked ? T.primary : T.borderHover, position: 'relative',
    }}>
      <div style={{
        width: 18, height: 18, borderRadius: '50%', background: '#fff', position: 'absolute',
        top: 2, left: checked ? 20 : 2, transition: 'left 0.2s',
      }} />
    </div>
  );
}

// ── Gráfico de barras CSS ──
function BarChart({ data, height = 120, color = T.primary, formatValue }: { data: { label: string; value: number }[]; height?: number; color?: string; formatValue?: (v: number) => string }) {
  const max = Math.max(...data.map(d => d.value), 1);
  const fmt = formatValue || ((v: number) => String(v));
  return (
    <div style={{ display: 'flex', alignItems: 'flex-end', gap: 2, height, padding: '0 4px' }}>
      {data.map(d => (
        <div key={d.label} style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', height: '100%', justifyContent: 'flex-end' }}>
          <div style={{ flex: 1, width: '100%', display: 'flex', alignItems: 'flex-end' }}>
            <div style={{ width: '100%', background: color, borderRadius: '3px 3px 0 0', height: `${(d.value / max) * 100}%`, minHeight: d.value > 0 ? 2 : 0, transition: 'height 0.3s' }} title={`${d.label}: ${fmt(d.value)}`} />
          </div>
          <div style={{ fontSize: 9, color: T.textMuted, marginTop: 4, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '100%', textAlign: 'center' }}>{d.label.slice(-5)}</div>
        </div>
      ))}
    </div>
  );
}

// ── Dashboard Tab ──
function DashboardTab() {
  const [metrics, setMetrics] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/admin/chat/dashboard').then((res: any) => {
      setMetrics(res?.data || res);
    }).catch(() => {}).finally(() => setLoading(false));
  }, []);

  if (loading) return <div style={{ padding: 16 }}><SkeletonBar width="50%" height={14} style={{ marginBottom: 8 }} /><SkeletonBar width="30%" height={14} /></div>;

  const cards = [
    { label: 'Total de Conversas', value: metrics?.total_conversations || 0, color: T.primary },
    { label: 'Mensagens Hoje', value: metrics?.messages_today || 0, color: T.success },
    { label: 'Tokens Totais', value: (metrics?.total_tokens || 0).toLocaleString(), color: T.warning },
    { label: 'Custo Total', value: `$${(metrics?.total_cost || 0).toFixed(4)}`, color: T.danger },
  ];

  const messagesPerDay = (metrics?.messages_per_day || []).map((d: any) => ({ label: d.date, value: d.count }));
  const topCustomers: any[] = metrics?.top_customers || [];
  const topModels: any[] = metrics?.top_models || [];
  const recentErrors: any[] = metrics?.recent_errors || [];

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>
      {/* Cards de métricas */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 16 }}>
        {cards.map(c => (
          <div key={c.label} style={s.metricCard}>
            <div style={{ fontSize: 12, color: T.textSecondary, fontWeight: 500, marginBottom: 8 }}>{c.label}</div>
            <div style={{ fontSize: 28, fontWeight: 700, color: c.color }}>{c.value}</div>
          </div>
        ))}
      </div>

      {/* Gráfico mensagens por dia */}
      {messagesPerDay.length > 0 && (
        <div style={s.card}>
          <div style={{ fontSize: 14, fontWeight: 600, color: T.text, marginBottom: 16 }}>Mensagens por Dia (7 dias)</div>
          <BarChart data={messagesPerDay} height={140} />
        </div>
      )}

      {/* Grid: Top Customers + Top Modelos */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
        <div style={s.card}>
          <div style={{ fontSize: 14, fontWeight: 600, color: T.text, marginBottom: 12 }}>Top 5 Customers por Custo</div>
          {topCustomers.length === 0 ? <div style={{ color: T.textMuted, fontSize: 13 }}>Sem dados</div> : (
            <table style={s.table}>
              <thead><tr><th style={s.th}>Email</th><th style={s.th}>Msgs</th><th style={s.th}>Custo</th></tr></thead>
              <tbody>
                {topCustomers.map((u: any, i: number) => (
                  <tr key={i} style={{ background: i % 2 === 0 ? 'transparent' : T.bgSubtle }}>
                    <td style={{ ...s.td, fontSize: 12 }}>{u.email || u.name || '-'}</td>
                    <td style={{ ...s.td, fontSize: 12 }}>{u.total_messages}</td>
                    <td style={{ ...s.td, fontSize: 12 }}>${Number(u.total_cost || 0).toFixed(4)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
        <div style={s.card}>
          <div style={{ fontSize: 14, fontWeight: 600, color: T.text, marginBottom: 12 }}>Top 5 Modelos</div>
          {topModels.length === 0 ? <div style={{ color: T.textMuted, fontSize: 13 }}>Sem dados</div> : (
            <table style={s.table}>
              <thead><tr><th style={s.th}>Modelo</th><th style={s.th}>Usos</th><th style={s.th}>Custo</th></tr></thead>
              <tbody>
                {topModels.map((m: any, i: number) => (
                  <tr key={i} style={{ background: i % 2 === 0 ? 'transparent' : T.bgSubtle }}>
                    <td style={{ ...s.td, fontSize: 12 }}>{m.model}</td>
                    <td style={{ ...s.td, fontSize: 12 }}>{m.usage_count}</td>
                    <td style={{ ...s.td, fontSize: 12 }}>${Number(m.total_cost || 0).toFixed(4)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>

      {/* Erros recentes */}
      {recentErrors.length > 0 && (
        <div style={s.card}>
          <div style={{ fontSize: 14, fontWeight: 600, color: T.text, marginBottom: 12 }}>Erros Recentes</div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            {recentErrors.map((e: any, i: number) => (
              <div key={i} style={{ padding: '10px 14px', background: T.dangerBg, border: `1px solid ${T.dangerBg}`, borderRadius: 8, fontSize: 12 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
                  <span style={{ color: T.danger, fontWeight: 600 }}>{e.customer_email || 'Desconhecido'}</span>
                  <span style={{ color: T.textMuted, fontSize: 11 }}>{e.created_at ? new Date(e.created_at).toLocaleString('pt-BR') : ''}</span>
                </div>
                <div style={{ color: T.text, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '100%' }}>{(e.content || '').slice(0, 200)}</div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

// ── Users Tab ──
function UsersTab() {
  const [users, setUsers] = useState<any[]>([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [expandedId, setExpandedId] = useState<string | null>(null);
  const [editLimits, setEditLimits] = useState<any>({});
  const [saving, setSaving] = useState(false);
  const [saveMsg, setSaveMsg] = useState('');
  const limit = 20;

  const fetchUsers = () => {
    setLoading(true);
    api.get(`/admin/chat/users?page=${page}&limit=${limit}`).then((res: any) => {
      const d = res?.data || res;
      setUsers(d?.users || []);
      setTotal(d?.total || 0);
    }).catch(() => {}).finally(() => setLoading(false));
  };

  useEffect(() => { fetchUsers(); }, [page]);

  const expand = (u: any) => {
    if (expandedId === u.id) { setExpandedId(null); return; }
    setExpandedId(u.id);
    setEditLimits(u.limits || {
      max_conversations: 50, max_messages_per_conversation: 500,
      max_input_length: 10000, rate_limit_rpm: 10,
      allowed_models: '*', blocked_models: '[]', status: 'active',
    });
    setSaveMsg('');
  };

  const saveLimits = async (userId: string) => {
    setSaving(true);
    setSaveMsg('');
    try {
      await api.put(`/admin/chat/users/${userId}/limits`, editLimits);
      setSaveMsg('Salvo com sucesso');
      fetchUsers();
    } catch { setSaveMsg('Erro ao salvar'); }
    finally { setSaving(false); setTimeout(() => setSaveMsg(''), 3000); }
  };

  const totalPages = Math.ceil(total / limit);

  return (
    <div>
      <div style={{ ...s.card, padding: 0, overflow: 'auto' }}>
        <table style={s.table}>
          <thead>
            <tr>
              <th style={s.th}>Email</th>
              <th style={s.th}>Conversas</th>
              <th style={s.th}>Mensagens</th>
              <th style={s.th}>Tokens</th>
              <th style={s.th}>Custo Total</th>
              <th style={s.th}>Último Uso</th>
              <th style={s.th}>Status</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={7} style={{ padding: 16 }}><div style={{ display: 'flex', gap: 16 }}><SkeletonBar width="25%" height={14} /><SkeletonBar width="35%" height={14} /><SkeletonBar width="20%" height={14} /></div></td></tr>
            ) : users.length === 0 ? (
              <tr><td colSpan={7} style={{ ...s.td, textAlign: 'center', color: T.textMuted }}>Nenhum usuário encontrado</td></tr>
            ) : users.map((u, i) => (
              <>
                <tr key={u.id} onClick={() => expand(u)} style={{ cursor: 'pointer', background: expandedId === u.id ? T.primaryBg : i % 2 === 0 ? 'transparent' : T.bgSubtle }}>
                  <td style={{ ...s.td, fontSize: 12, fontWeight: 500 }}>{u.email || u.name || u.id?.slice(0, 8)}</td>
                  <td style={s.td}>{u.conversations}</td>
                  <td style={s.td}>{u.total_messages}</td>
                  <td style={{ ...s.td, fontSize: 12 }}>{Number(u.total_tokens || 0).toLocaleString()}</td>
                  <td style={{ ...s.td, fontSize: 12 }}>${Number(u.total_cost || 0).toFixed(4)}</td>
                  <td style={{ ...s.td, fontSize: 11, color: T.textMuted }}>{u.last_activity ? new Date(u.last_activity).toLocaleDateString('pt-BR') : '-'}</td>
                  <td style={s.td}>
                    <span style={{
                      padding: '2px 8px', borderRadius: 6, fontSize: 11, fontWeight: 600,
                      background: (u.limits?.status || 'active') === 'active' ? T.successBg : (u.limits?.status) === 'suspended' ? T.warningBg : T.dangerBg,
                      color: (u.limits?.status || 'active') === 'active' ? T.success : (u.limits?.status) === 'suspended' ? T.warning : T.danger,
                    }}>{u.limits?.status || 'active'}</span>
                  </td>
                </tr>
                {expandedId === u.id && (
                  <tr key={`${u.id}-exp`}>
                    <td colSpan={7} style={{ padding: '20px 24px', background: T.bgSubtle, borderBottom: `1px solid ${T.border}` }}>
                      <div style={{ fontSize: 13, fontWeight: 600, color: T.text, marginBottom: 16 }}>Limites do usuário</div>
                      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 12 }}>
                        {([
                          ['max_conversations', 'Max Conversas'],
                          ['max_messages_per_conversation', 'Max Msgs/Conversa'],
                          ['max_input_length', 'Max Input'],
                          ['rate_limit_rpm', 'Rate Limit (RPM)'],
                        ] as const).map(([key, label]) => (
                          <div key={key}>
                            <div style={{ fontSize: 11, color: T.textSecondary, marginBottom: 4 }}>{label}</div>
                            <input type="number" style={s.input} value={editLimits[key] ?? ''} onInput={(e: any) => setEditLimits((p: any) => ({ ...p, [key]: parseInt(e.target.value) || 0 }))} />
                          </div>
                        ))}
                        <div>
                          <div style={{ fontSize: 11, color: T.textSecondary, marginBottom: 4 }}>Modelos Permitidos</div>
                          <Input value={editLimits.allowed_models ?? '*'} onChange={(v) => setEditLimits((p: any) => ({ ...p, allowed_models: v }))} />
                        </div>
                        <div>
                          <div style={{ fontSize: 11, color: T.textSecondary, marginBottom: 4 }}>Status</div>
                          <Select style={{ cursor: 'pointer' }} value={editLimits.status || 'active'} onChange={(v) => setEditLimits((p: any) => ({ ...p, status: v }))} options={[{ value: 'active', label: 'Ativo' }, { value: 'suspended', label: 'Suspenso' }, { value: 'blocked', label: 'Bloqueado' }]} />
                        </div>
                      </div>
                      <div style={{ display: 'flex', gap: 12, alignItems: 'center', marginTop: 16 }}>
                        <Button variant="primary" size="sm" onClick={() => saveLimits(u.id)} disabled={saving}>
                          {saving ? 'Salvando...' : 'Salvar Limites'}
                        </Button>
                        {saveMsg && <span style={{ fontSize: 12, color: saveMsg.includes('sucesso') ? T.success : T.danger }}>{saveMsg}</span>}
                      </div>
                    </td>
                  </tr>
                )}
              </>
            ))}
          </tbody>
        </table>
      </div>
      {totalPages > 1 && (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 12, marginTop: 16 }}>
          <Button variant="ghost" size="sm" onClick={() => setPage(p => Math.max(1, p - 1))} disabled={page === 1}>{Icons.chevronLeft} Anterior</Button>
          <span style={{ fontSize: 13, color: T.textSecondary }}>Página {page} de {totalPages}</span>
          <Button variant="ghost" size="sm" onClick={() => setPage(p => Math.min(totalPages, p + 1))} disabled={page >= totalPages}>Próxima {Icons.chevronRight}</Button>
        </div>
      )}
    </div>
  );
}

// ── Analytics Tab ──
function AnalyticsTab() {
  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/admin/chat/analytics').then((res: any) => {
      setData(res?.data || res);
    }).catch(() => {}).finally(() => setLoading(false));
  }, []);

  if (loading) return <div style={{ padding: 16 }}><SkeletonBar width="50%" height={14} style={{ marginBottom: 8 }} /><SkeletonBar width="30%" height={14} /></div>;

  const msgsPerDay = (data?.messages_per_day || []).map((d: any) => ({ label: d.date, value: d.count }));
  const costPerDay = (data?.cost_per_day || []).map((d: any) => ({ label: d.date, value: d.cost }));
  const topModels: any[] = data?.top_models || [];
  const topCustomers: any[] = data?.top_customers || [];

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>
      {/* Gráficos */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
        <div style={s.card}>
          <div style={{ fontSize: 14, fontWeight: 600, color: T.text, marginBottom: 16 }}>Mensagens por Dia (30 dias)</div>
          {msgsPerDay.length === 0 ? <div style={{ color: T.textMuted, fontSize: 13 }}>Sem dados</div> : <BarChart data={msgsPerDay} height={160} />}
        </div>
        <div style={s.card}>
          <div style={{ fontSize: 14, fontWeight: 600, color: T.text, marginBottom: 16 }}>Custo por Dia (30 dias)</div>
          {costPerDay.length === 0 ? <div style={{ color: T.textMuted, fontSize: 13 }}>Sem dados</div> : <BarChart data={costPerDay} height={160} color={T.success} formatValue={(v: number) => `$${v.toFixed(4)}`} />}
        </div>
      </div>

      {/* Tabelas */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
        <div style={s.card}>
          <div style={{ fontSize: 14, fontWeight: 600, color: T.text, marginBottom: 12 }}>Ranking de Modelos por Uso</div>
          {topModels.length === 0 ? <div style={{ color: T.textMuted, fontSize: 13 }}>Sem dados</div> : (
            <table style={s.table}>
              <thead><tr><th style={s.th}>Modelo</th><th style={s.th}>Usos</th><th style={s.th}>Tokens</th><th style={s.th}>Custo</th></tr></thead>
              <tbody>
                {topModels.map((m: any, i: number) => (
                  <tr key={i} style={{ background: i % 2 === 0 ? 'transparent' : T.bgSubtle }}>
                    <td style={{ ...s.td, fontSize: 12 }}>{m.model}</td>
                    <td style={{ ...s.td, fontSize: 12 }}>{m.usage_count}</td>
                    <td style={{ ...s.td, fontSize: 12 }}>{Number(m.total_tokens || 0).toLocaleString()}</td>
                    <td style={{ ...s.td, fontSize: 12 }}>${Number(m.total_cost || 0).toFixed(4)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
        <div style={s.card}>
          <div style={{ fontSize: 14, fontWeight: 600, color: T.text, marginBottom: 12 }}>Ranking de Customers por Custo</div>
          {topCustomers.length === 0 ? <div style={{ color: T.textMuted, fontSize: 13 }}>Sem dados</div> : (
            <table style={s.table}>
              <thead><tr><th style={s.th}>Email</th><th style={s.th}>Msgs</th><th style={s.th}>Custo</th></tr></thead>
              <tbody>
                {topCustomers.map((u: any, i: number) => (
                  <tr key={i} style={{ background: i % 2 === 0 ? 'transparent' : T.bgSubtle }}>
                    <td style={{ ...s.td, fontSize: 12 }}>{u.email || u.name || '-'}</td>
                    <td style={{ ...s.td, fontSize: 12 }}>{u.total_messages}</td>
                    <td style={{ ...s.td, fontSize: 12 }}>${Number(u.total_cost || 0).toFixed(4)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
}

// ── Checkbox estilizado ──
function Checkbox({ checked, onChange }: { checked: boolean; onChange: (v: boolean) => void }) {
  return (
    <div onClick={() => onChange(!checked)} style={{
      width: 20, height: 20, borderRadius: 5, cursor: 'pointer', transition: 'all 0.15s',
      background: checked ? T.primary : T.bgHover,
      border: checked ? `2px solid ${T.primary}` : `2px solid ${T.whiteAlpha15}`,
      display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
    }}>
      {checked && <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>}
    </div>
  );
}

// ── Cores dos providers ──
const PROVIDER_COLORS: Record<string, string> = {
  anthropic: T.warningHover, openai: T.success, google: T.primary, 'google-ai': T.primary,
  meta: T.purple, mistral: '#F43F5E', cohere: '#06B6D4', 'elon-router': T.textMuted,
};

function getProviderColor(provider: string): string {
  const key = (provider || '').toLowerCase();
  for (const [k, v] of Object.entries(PROVIDER_COLORS)) {
    if (key.includes(k)) return v;
  }
  return T.textMuted;
}

function getProviderLabel(provider: string): string {
  const key = (provider || '').toLowerCase();
  if (key.includes('anthropic')) return 'Anthropic';
  if (key.includes('openai')) return 'OpenAI';
  if (key.includes('google')) return 'Google';
  if (key.includes('meta')) return 'Meta';
  if (key.includes('mistral')) return 'Mistral';
  if (key.includes('cohere')) return 'Cohere';
  return provider || 'Outro';
}

// ── Config Tab (redesenhado) ──
function ConfigTab() {
  const [configs, setConfigs] = useState<Record<string, any>>({});
  const [configMeta, setConfigMeta] = useState<Record<string, any>>({});
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);
  const [loading, setLoading] = useState(true);
  const [models, setModels] = useState<any[]>([]);
  const [modelsLoading, setModelsLoading] = useState(true);
  const [apiVersion, setApiVersion] = useState('v2');
  const [allowedModels, setAllowedModels] = useState<string[]>([]);
  const [defaultModel, setDefaultModel] = useState('auto');

  // Carregar configs
  useEffect(() => {
    api.get('/admin/chat/config').then((res: any) => {
      const items = res?.data?.configs || res?.configs || [];
      const map: Record<string, any> = {};
      const meta: Record<string, any> = {};
      for (const item of items) {
        map[item.key] = item.value;
        meta[item.key] = { type: item.type, description: item.description };
      }
      setConfigs(map);
      setConfigMeta(meta);
      // Parsear allowed_models — '*' = todos permitidos
      const rawAllowed = map.allowed_models || '*';
      if (rawAllowed === '*') {
        setAllowedModels(['*']); // wildcard = todos
      } else {
        try {
          const am = JSON.parse(rawAllowed);
          if (Array.isArray(am) && am.length > 0) setAllowedModels(am);
          else setAllowedModels(['*']); // array vazio = todos
        } catch { setAllowedModels(['*']); }
      }
      setDefaultModel(map.default_model || 'auto');
    }).catch(() => {}).finally(() => setLoading(false));
  }, []);

  // Carregar modelos disponíveis
  useEffect(() => {
    api.get('/admin/chat/models').then((res: any) => {
      const d = res?.data || res;
      setModels(d?.models || []);
      if (d?.api_version) setApiVersion(d.api_version);
    }).catch(() => {}).finally(() => setModelsLoading(false));
  }, []);

  // Verificar se modelo está permitido (wildcard = todos)
  const isModelAllowed = (modelId: string) => {
    return allowedModels.includes('*') || allowedModels.includes(modelId);
  };

  const toggleModel = (modelId: string) => {
    setAllowedModels(prev => {
      let next: string[];
      if (prev.includes('*')) {
        // Estava em wildcard — desmarcar um = listar todos MENOS esse
        next = models.filter(m => m.id !== 'auto' && m.id !== modelId).map(m => m.id);
      } else if (prev.includes(modelId)) {
        next = prev.filter(m => m !== modelId);
      } else {
        next = [...prev, modelId];
      }
      // Se todos estão selecionados, voltar pra wildcard
      const allIds = models.filter(m => m.id !== 'auto').map(m => m.id);
      if (allIds.length > 0 && allIds.every(id => next.includes(id))) {
        next = ['*'];
        setConfigs(p => ({ ...p, allowed_models: '*' }));
      } else {
        setConfigs(p => ({ ...p, allowed_models: JSON.stringify(next) }));
      }
      // Se o modelo padrão foi removido, resetar
      if (!next.includes('*') && !next.includes(defaultModel) && defaultModel !== 'auto') {
        setDefaultModel('auto');
        setConfigs(p => ({ ...p, default_model: 'auto' }));
      }
      return next;
    });
  };

  const changeDefault = (val: string) => {
    setDefaultModel(val);
    setConfigs(p => ({ ...p, default_model: val }));
  };

  const save = async () => {
    setSaving(true);
    try {
      await api.put('/admin/chat/config', configs);
      setSaved(true);
      setTimeout(() => setSaved(false), 3000);
    } catch {} finally { setSaving(false); }
  };

  if (loading) return <div style={{ padding: 16 }}><SkeletonBar width="50%" height={14} style={{ marginBottom: 8 }} /><SkeletonBar width="30%" height={14} /></div>;

  // Agrupar modelos por provider
  const grouped: Record<string, any[]> = {};
  for (const m of models) {
    const label = getProviderLabel(m.provider);
    if (!grouped[label]) grouped[label] = [];
    grouped[label].push(m);
  }

  // Modelos permitidos para dropdown de modelo padrão
  const allowedForDefault = models.filter(m => m.id !== 'auto' && isModelAllowed(m.id));

  // Chaves de limites
  const limitKeys = ['max_tokens_output', 'max_input_length', 'max_conversations_per_user', 'max_messages_per_conversation', 'rate_limit_rpm', 'max_history_messages', 'min_balance_to_chat'];
  // Chaves de features (boolean)
  const featureKeys = ['enable_streaming', 'enable_attachments', 'enable_tts', 'enable_compliance_scan'];

  const sectionStyle = { marginBottom: 32 } as any;
  const sectionTitle = (label: string, icon?: any) => (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 16 }}>
      {icon && <span style={{ color: T.primary, display: 'flex' }}>{icon}</span>}
      <h3 style={{ fontSize: 16, fontWeight: 600, color: T.text, margin: 0 }}>{label}</h3>
    </div>
  );

  return (
    <div>
      {/* ── Seção 1: Informações do Sistema ── */}
      <div style={sectionStyle}>
        {sectionTitle('Informações do Sistema', <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><path d="M12 16v-4"/><path d="M12 8h.01"/></svg>)}
        <div style={{ ...s.card, display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 16 }}>
          <div>
            <div style={{ fontSize: 11, color: T.textSecondary, marginBottom: 4, textTransform: 'uppercase', letterSpacing: '0.5px', fontWeight: 600 }}>Versão da API</div>
            <div style={{ fontSize: 20, fontWeight: 700, color: T.primary }}>{apiVersion.toUpperCase()}</div>
          </div>
          <div>
            <div style={{ fontSize: 11, color: T.textSecondary, marginBottom: 4, textTransform: 'uppercase', letterSpacing: '0.5px', fontWeight: 600 }}>Streaming</div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <span style={{ width: 8, height: 8, borderRadius: '50%', background: (configs.enable_streaming === 'true' || configs.enable_streaming === true) ? T.success : T.danger }} />
              <span style={{ fontSize: 14, fontWeight: 600, color: T.text }}>{(configs.enable_streaming === 'true' || configs.enable_streaming === true) ? 'Ativo' : 'Desativado'}</span>
            </div>
          </div>
          <div>
            <div style={{ fontSize: 11, color: T.textSecondary, marginBottom: 4, textTransform: 'uppercase', letterSpacing: '0.5px', fontWeight: 600 }}>Modelos Disponíveis</div>
            <div style={{ fontSize: 20, fontWeight: 700, color: T.text }}>{models.length}</div>
          </div>
        </div>
        {/* System prompt global */}
        {'system_prompt_global' in configs && (
          <div style={{ marginTop: 16 }}>
            <div style={{ fontSize: 13, fontWeight: 600, color: T.text, marginBottom: 6 }}>System Prompt Global</div>
            <Textarea
              style={{ ...s.textarea, minHeight: 100 }}
              value={configs.system_prompt_global || ''}
              onInput={(e: any) => setConfigs(p => ({ ...p, system_prompt_global: e.target.value }))}
              placeholder="Prompt do sistema aplicado a todas as conversas..."
            />
          </div>
        )}
      </div>

      {/* ── Seção 2: Modelos Disponíveis ── */}
      <div style={sectionStyle}>
        {sectionTitle('Modelos Disponíveis', <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2L2 7l10 5 10-5-10-5z"/><path d="M2 17l10 5 10-5"/><path d="M2 12l10 5 10-5"/></svg>)}
        <p style={{ fontSize: 12, color: T.textMuted, marginTop: -8, marginBottom: 16 }}>
          Marque os modelos que ficam disponíveis para os usuários no chat. Modelos desmarcados ficam ocultos.
        </p>
        {modelsLoading ? (
          <div style={{ padding: 16 }}><SkeletonBar width="50%" height={14} style={{ marginBottom: 8 }} /><SkeletonBar width="30%" height={14} /></div>
        ) : models.length === 0 ? (
          <div style={{ ...s.card, color: T.textMuted, textAlign: 'center', padding: 40 }}>
            Nenhum modelo encontrado. Verifique a conexão com o Elon Router.
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
            {Object.entries(grouped).sort(([a], [b]) => a.localeCompare(b)).map(([provider, provModels]) => {
              const color = getProviderColor(provider);
              return (
                <div key={provider}>
                  {/* Provider header */}
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 10 }}>
                    <span style={{
                      padding: '3px 10px', borderRadius: 6, fontSize: 11, fontWeight: 700,
                      background: `${color}20`, color, textTransform: 'uppercase', letterSpacing: '0.5px',
                    }}>{provider}</span>
                    <span style={{ fontSize: 11, color: T.textMuted }}>{provModels.length} modelo{provModels.length > 1 ? 's' : ''}</span>
                  </div>
                  {/* Modelos */}
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 8 }}>
                    {provModels.map((m: any) => {
                      const isChecked = isModelAllowed(m.id);
                      return (
                        <div
                          key={m.id}
                          onClick={() => toggleModel(m.id)}
                          style={{
                            ...s.card, padding: '12px 14px', cursor: 'pointer',
                            display: 'flex', alignItems: 'center', gap: 12,
                            border: isChecked ? `1px solid ${color}40` : `1px solid ${T.border}`,
                            background: isChecked ? `${color}08` : T.bgCard,
                            transition: 'all 0.15s',
                          }}
                        >
                          <Checkbox checked={isChecked} onChange={() => toggleModel(m.id)} />
                          <div style={{ flex: 1, minWidth: 0 }}>
                            <div style={{ fontSize: 13, fontWeight: 500, color: T.text, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{m.name}</div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>

      {/* ── Seção 3: Modelo Padrão ── */}
      <div style={sectionStyle}>
        {sectionTitle('Modelo Padrão', <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87L18.18 21 12 17.27 5.82 21 7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>)}
        <div style={s.card}>
          <p style={{ fontSize: 12, color: T.textMuted, marginBottom: 12 }}>
            Modelo usado quando o usuário não escolhe um. Apenas modelos permitidos aparecem aqui.
          </p>
          <select
            style={{ ...s.input, maxWidth: 400, cursor: 'pointer' }}
            value={defaultModel}
            onChange={(e: any) => changeDefault(e.target.value)}
          >
            <option value="auto">Automático (auto)</option>
            {allowedForDefault.map((m: any) => (
              <option key={m.id} value={m.id}>{m.name} ({getProviderLabel(m.provider)})</option>
            ))}
          </select>
        </div>
      </div>

      {/* ── Seção 4: Limites ── */}
      <div style={sectionStyle}>
        {sectionTitle('Limites', <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>)}
        <div style={{ ...s.card, display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 16 }}>
          {limitKeys.filter(k => k in configs).map(key => {
            const meta = configMeta[key] || {};
            return (
              <div key={key}>
                <div style={{ fontSize: 12, fontWeight: 600, color: T.text, marginBottom: 4 }}>{key.replace(/_/g, ' ')}</div>
                {meta.description && <div style={{ fontSize: 10, color: T.textMuted, marginBottom: 4 }}>{meta.description}</div>}
                <input
                  type="number"
                  style={s.input}
                  value={configs[key]}
                  onInput={(e: any) => setConfigs(p => ({ ...p, [key]: e.target.value }))}
                />
              </div>
            );
          })}
        </div>
      </div>

      {/* ── Seção 5: Features ── */}
      <div style={sectionStyle}>
        {sectionTitle('Features', <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>)}
        <div style={{ ...s.card, display: 'flex', flexDirection: 'column', gap: 16 }}>
          {featureKeys.filter(k => k in configs).map(key => {
            const meta = configMeta[key] || {};
            const isOn = configs[key] === 'true' || configs[key] === true;
            const labels: Record<string, string> = {
              enable_streaming: 'Streaming',
              enable_attachments: '📎 Anexos',
              enable_tts: '🔊 Text-to-Speech',
              enable_compliance_scan: 'Scan de Compliance',
            };
            return (
              <div key={key} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <div>
                  <div style={{ fontSize: 14, fontWeight: 500, color: T.text }}>{labels[key] || key}</div>
                  {meta.description && <div style={{ fontSize: 11, color: T.textMuted }}>{meta.description}</div>}
                </div>
                <Toggle checked={isOn} onChange={(v) => setConfigs(p => ({ ...p, [key]: String(v) }))} />
              </div>
            );
          })}
        </div>
      </div>

      {/* ── Botão Salvar ── */}
      <div style={{ display: 'flex', gap: 12, alignItems: 'center', padding: '16px 0' }}>
        <Button
          variant="primary"
          style={{ padding: '12px 32px', fontSize: 15, fontWeight: 700 }}
          onClick={save} disabled={saving}
        >
          {saving ? 'Salvando...' : saved ? 'Salvo!' : 'Salvar Configurações'}
        </Button>
        {saved && <span style={{ color: T.success, fontSize: 13, display: 'flex', alignItems: 'center', gap: 4 }}>{Icons.check} Configurações salvas com sucesso</span>}
      </div>
    </div>
  );
}

// ── Conversations Tab ──
function ConversationsTab() {
  const [conversations, setConversations] = useState<any[]>([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [search, setSearch] = useState('');
  const [modelFilter, setModelFilter] = useState('');
  const [selected, setSelected] = useState<Set<string>>(new Set());
  const [expandedId, setExpandedId] = useState<string | null>(null);
  const [expandedMessages, setExpandedMessages] = useState<any[]>([]);
  const [loadingMessages, setLoadingMessages] = useState(false);
  const limit = 25;

  const fetchConvs = () => {
    setLoading(true);
    const params = new URLSearchParams({ limit: String(limit), offset: String(page * limit) });
    if (search) params.set('search', search);
    if (modelFilter) params.set('model', modelFilter);
    api.get(`/admin/chat/conversations?${params}`).then((res: any) => {
      setConversations(res?.conversations || []);
      setTotal(res?.total || 0);
    }).catch(() => {}).finally(() => setLoading(false));
  };

  useEffect(() => { fetchConvs(); }, [page, search, modelFilter]);

  const expandConv = async (id: string) => {
    if (expandedId === id) { setExpandedId(null); return; }
    setExpandedId(id);
    setLoadingMessages(true);
    try {
      const res: any = await api.get(`/admin/chat/conversations/${id}`);
      setExpandedMessages(res?.messages || []);
    } catch {} finally { setLoadingMessages(false); }
  };

  const deleteConv = async (id: string) => {
    if (!confirm('Deletar conversa permanentemente?')) return;
    await api.delete(`/admin/chat/conversations/${id}`);
    fetchConvs();
  };

  const bulkDelete = async () => {
    if (selected.size === 0) return;
    if (!confirm(`Deletar ${selected.size} conversas permanentemente?`)) return;
    await api.post('/admin/chat/conversations/bulk', { action: 'delete', ids: Array.from(selected) });
    setSelected(new Set());
    fetchConvs();
  };

  const toggleSelect = (id: string) => {
    setSelected(prev => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id); else next.add(id);
      return next;
    });
  };

  const toggleAll = () => {
    if (selected.size === conversations.length) setSelected(new Set());
    else setSelected(new Set(conversations.map(c => c.id)));
  };

  const totalPages = Math.ceil(total / limit);

  return (
    <div>
      {/* Filtros */}
      <div style={{ display: 'flex', gap: 12, marginBottom: 16, flexWrap: 'wrap', alignItems: 'center' }}>
        <div style={{ position: 'relative', flex: 1, minWidth: 200 }}>
          <input
            type="text" placeholder="Buscar por ID, titulo..."
            style={{ ...s.input, paddingLeft: 36 }}
            value={search}
            onInput={(e: any) => { setSearch(e.target.value); setPage(0); }}
          />
          <span style={{ position: 'absolute', left: 10, top: '50%', transform: 'translateY(-50%)', color: T.textMuted }}>{Icons.search}</span>
        </div>
        <input
          type="text" placeholder="Modelo" style={{ ...s.input, width: 160, flex: 'none' }}
          value={modelFilter} onInput={(e: any) => { setModelFilter(e.target.value); setPage(0); }}
        />
        {selected.size > 0 && (
          <Button variant="danger" size="sm" onClick={bulkDelete}>
            {Icons.trash} Deletar {selected.size}
          </Button>
        )}
        <span style={{ fontSize: 12, color: T.textMuted }}>{total} conversas</span>
      </div>

      {/* Tabela */}
      <div style={{ ...s.card, padding: 0, overflow: 'auto' }}>
        <table style={s.table}>
          <thead>
            <tr>
              <th style={s.th}><input type="checkbox" checked={selected.size === conversations.length && conversations.length > 0} onChange={toggleAll} /></th>
              <th style={s.th}>ID</th>
              <th style={s.th}>Customer</th>
              <th style={s.th}>Titulo</th>
              <th style={s.th}>Modelo</th>
              <th style={s.th}>Msgs</th>
              <th style={s.th}>Tokens</th>
              <th style={s.th}>Custo</th>
              <th style={s.th}>Atualizado</th>
              <th style={s.th}>Ações</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={10} style={{ padding: 16 }}><div style={{ display: 'flex', gap: 16 }}><SkeletonBar width="25%" height={14} /><SkeletonBar width="35%" height={14} /><SkeletonBar width="20%" height={14} /></div></td></tr>
            ) : conversations.length === 0 ? (
              <tr><td colSpan={10} style={{ ...s.td, textAlign: 'center', color: T.textMuted }}>Nenhuma conversa encontrada</td></tr>
            ) : conversations.map(c => (
              <>
                <tr key={c.id} style={{ cursor: 'pointer', background: expandedId === c.id ? T.primaryBg : undefined }} onClick={() => expandConv(c.id)}>
                  <td style={s.td} onClick={(e: any) => e.stopPropagation()}>
                    <input type="checkbox" checked={selected.has(c.id)} onChange={() => toggleSelect(c.id)} />
                  </td>
                  <td style={{ ...s.td, fontFamily: 'monospace', fontSize: 11 }}>{(c.id || '').slice(0, 8)}</td>
                  <td style={{ ...s.td, fontSize: 12 }}>{c.customer_email || c.customer_id?.slice(0, 8)}</td>
                  <td style={{ ...s.td, maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{c.title || 'Sem titulo'}</td>
                  <td style={{ ...s.td, fontSize: 12, color: T.textSecondary }}>{c.model || '-'}</td>
                  <td style={s.td}>{c.msg_count || c.message_count || 0}</td>
                  <td style={{ ...s.td, fontSize: 12 }}>{(c.total_tokens || 0).toLocaleString()}</td>
                  <td style={{ ...s.td, fontSize: 12 }}>${(c.total_cost || 0).toFixed(4)}</td>
                  <td style={{ ...s.td, fontSize: 11, color: T.textMuted }}>{c.updated_at ? new Date(c.updated_at).toLocaleDateString('pt-BR') : '-'}</td>
                  <td style={s.td} onClick={(e: any) => e.stopPropagation()}>
                    <Button variant="ghost" size="xs" onClick={() => deleteConv(c.id)}>
                      {Icons.trash}
                    </Button>
                  </td>
                </tr>
                {expandedId === c.id && (
                  <tr key={`${c.id}-exp`}>
                    <td colSpan={10} style={{ padding: '16px 24px', background: T.bgSubtle, borderBottom: `1px solid ${T.border}` }}>
                      {loadingMessages ? (
                        <div style={{ padding: 16 }}><SkeletonBar width="50%" height={14} style={{ marginBottom: 8 }} /><SkeletonBar width="30%" height={14} /></div>
                      ) : expandedMessages.length === 0 ? (
                        <div style={{ color: T.textMuted, fontSize: 13 }}>Nenhuma mensagem</div>
                      ) : (
                        <div style={{ maxHeight: 400, overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: 8 }}>
                          {expandedMessages.map((m: any, i: number) => (
                            <div key={i} style={{
                              padding: '10px 14px', borderRadius: 10, maxWidth: '85%', fontSize: 13, lineHeight: 1.5,
                              alignSelf: m.role === 'user' ? 'flex-end' : 'flex-start',
                              background: m.role === 'user' ? T.primaryBg : T.bgCardHover,
                              color: T.text, border: m.role === 'user' ? `1px solid ${T.primaryBgStrong}` : `1px solid ${T.border}`,
                            }}>
                              <div style={{ fontSize: 10, color: T.textMuted, marginBottom: 4, fontWeight: 600 }}>
                                {m.role === 'user' ? 'Usuário' : 'Assistente'}
                                {m.model && <span style={{ marginLeft: 8, color: T.textSecondary }}>{m.model}</span>}
                                {m.tokens_in != null && <span style={{ marginLeft: 8, color: T.textSecondary }}>{m.tokens_in}+{m.tokens_out} tokens</span>}
                              </div>
                              <div style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{m.content}</div>
                            </div>
                          ))}
                        </div>
                      )}
                    </td>
                  </tr>
                )}
              </>
            ))}
          </tbody>
        </table>
      </div>

      {/* Paginação */}
      {totalPages > 1 && (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 12, marginTop: 16 }}>
          <Button variant="ghost" size="sm" onClick={() => setPage(p => Math.max(0, p - 1))} disabled={page === 0}>
            {Icons.chevronLeft} Anterior
          </Button>
          <span style={{ fontSize: 13, color: T.textSecondary }}>Página {page + 1} de {totalPages}</span>
          <Button variant="ghost" size="sm" onClick={() => setPage(p => Math.min(totalPages - 1, p + 1))} disabled={page >= totalPages - 1}>
            Próxima {Icons.chevronRight}
          </Button>
        </div>
      )}
    </div>
  );
}

// ── Compliance Tab ──
function ComplianceTab() {
  const [flags, setFlags] = useState<any[]>([]);
  const [total, setTotal] = useState(0);
  const [pendingCount, setPendingCount] = useState(0);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [filterType, setFilterType] = useState('');
  const [filterStatus, setFilterStatus] = useState('');
  const [actionLoading, setActionLoading] = useState<string | null>(null);
  const limit = 20;

  const fetchFlags = () => {
    setLoading(true);
    const params = new URLSearchParams({ page: String(page), limit: String(limit) });
    if (filterType) params.set('flag_type', filterType);
    if (filterStatus) params.set('action_taken', filterStatus);
    api.get(`/admin/chat/compliance?${params}`).then((res: any) => {
      const d = res?.data || res;
      setFlags(d?.flags || []);
      setTotal(d?.total || 0);
      setPendingCount(d?.pending_count || 0);
    }).catch(() => {}).finally(() => setLoading(false));
  };

  useEffect(() => { fetchFlags(); }, [page, filterType, filterStatus]);

  const handleAction = async (flagId: string, action: string) => {
    const msgs: Record<string, string> = {
      approve: 'Aprovar esta flag?',
      block_customer: 'Bloquear este customer? Ele não poderá mais usar o chat.',
      delete_conversation: 'Deletar a conversa inteira? Esta ação é irreversível.',
    };
    if (!confirm(msgs[action] || 'Confirmar ação?')) return;
    setActionLoading(flagId);
    try {
      await api.post(`/admin/chat/compliance/${flagId}`, { action });
      fetchFlags();
    } catch {} finally { setActionLoading(null); }
  };

  const typeLabels: Record<string, string> = { cpf: 'CPF', cartao_credito: 'Cartão', spam_email: 'Spam Email' };
  const statusColors: Record<string, { bg: string; color: string }> = {
    pending: { bg: T.warningBg, color: T.warning },
    approved: { bg: T.successBg, color: T.success },
    blocked: { bg: T.dangerBg, color: T.danger },
    deleted: { bg: T.borderHover, color: T.textMuted },
  };
  const totalPages = Math.ceil(total / limit);

  return (
    <div>
      <div style={{ display: 'flex', gap: 12, marginBottom: 16, alignItems: 'center' }}>
        <Select style={{ width: 160, flex: 'none' }} value={filterType} onChange={(v) => { setFilterType(v); setPage(1); }} options={[{ value: '', label: 'Todos os tipos' }, { value: 'cpf', label: 'CPF' }, { value: 'cartao_credito', label: 'Cartão de Crédito' }, { value: 'spam_email', label: 'Spam Email' }]} />
        <Select style={{ width: 160, flex: 'none' }} value={filterStatus} onChange={(v) => { setFilterStatus(v); setPage(1); }} options={[{ value: '', label: 'Todos os status' }, { value: 'pending', label: 'Pendente' }, { value: 'approved', label: 'Aprovado' }, { value: 'blocked', label: 'Bloqueado' }, { value: 'deleted', label: 'Deletado' }]} />
        <span style={{ fontSize: 12, color: T.textMuted }}>{total} flags total | {pendingCount} pendentes</span>
      </div>

      <div style={{ ...s.card, padding: 0, overflow: 'auto' }}>
        <table style={s.table}>
          <thead>
            <tr>
              <th style={s.th}>Customer</th>
              <th style={s.th}>Conteúdo</th>
              <th style={s.th}>Tipo</th>
              <th style={s.th}>Data</th>
              <th style={s.th}>Status</th>
              <th style={s.th}>Ações</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={6} style={{ padding: 16 }}><div style={{ display: 'flex', gap: 16 }}><SkeletonBar width="25%" height={14} /><SkeletonBar width="35%" height={14} /><SkeletonBar width="20%" height={14} /></div></td></tr>
            ) : flags.length === 0 ? (
              <tr><td colSpan={6} style={{ ...s.td, textAlign: 'center', color: T.textMuted }}>Nenhuma flag encontrada</td></tr>
            ) : flags.map((f: any, i: number) => (
              <tr key={f.id} style={{ background: i % 2 === 0 ? 'transparent' : T.bgSubtle }}>
                <td style={{ ...s.td, fontSize: 12 }}>{f.customer_email || f.customer_id?.slice(0, 8)}</td>
                <td style={{ ...s.td, fontSize: 12, maxWidth: 300, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{f.content_preview || '-'}</td>
                <td style={s.td}>
                  <span style={{ padding: '2px 8px', borderRadius: 6, fontSize: 11, fontWeight: 600, background: T.primaryBg, color: T.primary }}>
                    {typeLabels[f.flag_type] || f.flag_type}
                  </span>
                </td>
                <td style={{ ...s.td, fontSize: 11, color: T.textMuted }}>{f.created_at ? new Date(f.created_at).toLocaleString('pt-BR') : '-'}</td>
                <td style={s.td}>
                  <span style={{ padding: '2px 8px', borderRadius: 6, fontSize: 11, fontWeight: 600, ...(statusColors[f.action_taken] || statusColors.pending) }}>
                    {f.action_taken || 'pending'}
                  </span>
                </td>
                <td style={s.td}>
                  {f.action_taken === 'pending' && (
                    <div style={{ display: 'flex', gap: 4 }}>
                      <Button variant="ghost" size="xs" style={{ color: T.success }} onClick={() => handleAction(f.id, 'approve')} disabled={actionLoading === f.id}>
                        {Icons.check} Aprovar
                      </Button>
                      <Button variant="ghost" size="xs" style={{ color: T.danger }} onClick={() => handleAction(f.id, 'block_customer')} disabled={actionLoading === f.id}>
                        Bloquear
                      </Button>
                      <Button variant="ghost" size="xs" style={{ color: T.textMuted }} onClick={() => handleAction(f.id, 'delete_conversation')} disabled={actionLoading === f.id}>
                        {Icons.trash}
                      </Button>
                    </div>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {totalPages > 1 && (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 12, marginTop: 16 }}>
          <Button variant="ghost" size="sm" onClick={() => setPage(p => Math.max(1, p - 1))} disabled={page === 1}>{Icons.chevronLeft} Anterior</Button>
          <span style={{ fontSize: 13, color: T.textSecondary }}>Página {page} de {totalPages}</span>
          <Button variant="ghost" size="sm" onClick={() => setPage(p => Math.min(totalPages, p + 1))} disabled={page >= totalPages}>Próxima {Icons.chevronRight}</Button>
        </div>
      )}
    </div>
  );
}

// ── Cleanup Tab ──
function CleanupTab() {
  const [archiveDays, setArchiveDays] = useState(30);
  const [deleteDays, setDeleteDays] = useState(90);
  const [results, setResults] = useState<Record<string, { affected: number } | null>>({});
  const [loading, setLoading] = useState<string | null>(null);

  const runAction = async (action: string, days?: number) => {
    const msgs: Record<string, string> = {
      archive_old: `Arquivar conversas inativas há mais de ${days} dias?`,
      delete_archived: `Deletar conversas arquivadas há mais de ${days} dias? Irreversivel!`,
      delete_empty: 'Deletar todas as conversas sem mensagens?',
      delete_orphan: 'Deletar conversas cujo customer nao existe mais? Irreversivel!',
    };
    if (!confirm(msgs[action] || 'Confirmar?')) return;
    setLoading(action);
    try {
      const res: any = await api.post('/admin/chat/cleanup', { action, days });
      const d = res?.data || res;
      setResults(prev => ({ ...prev, [action]: { affected: d?.affected || 0 } }));
    } catch {
      setResults(prev => ({ ...prev, [action]: { affected: -1 } }));
    } finally { setLoading(null); }
  };

  const actions = [
    { id: 'archive_old', title: 'Arquivar conversas inativas', desc: 'Move conversas sem atividade para status arquivado', hasDays: true, days: archiveDays, setDays: setArchiveDays },
    { id: 'delete_archived', title: 'Deletar arquivadas antigas', desc: 'Remove permanentemente conversas arquivadas', hasDays: true, days: deleteDays, setDays: setDeleteDays },
    { id: 'delete_empty', title: 'Deletar conversas vazias', desc: 'Remove conversas que não possuem nenhuma mensagem', hasDays: false },
    { id: 'delete_orphan', title: 'Deletar conversas órfãs', desc: 'Remove conversas de customers que não existem mais', hasDays: false },
  ];

  return (
    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
      {actions.map(a => (
        <div key={a.id} style={s.card}>
          <div style={{ fontSize: 14, fontWeight: 600, color: T.text, marginBottom: 4 }}>{a.title}</div>
          <div style={{ fontSize: 12, color: T.textMuted, marginBottom: 16 }}>{a.desc}</div>
          {a.hasDays && (
            <div style={{ marginBottom: 12 }}>
              <div style={{ fontSize: 11, color: T.textSecondary, marginBottom: 4 }}>Dias de inatividade</div>
              <input type="number" style={{ ...s.input, width: 100 }} value={a.days} onInput={(e: any) => a.setDays?.(parseInt(e.target.value) || 0)} />
            </div>
          )}
          <Button
            variant={a.id.includes('delete') ? 'danger' : 'primary'}
            size="sm"
            onClick={() => runAction(a.id, a.hasDays ? a.days : undefined)}
            disabled={loading === a.id}
          >
            {loading === a.id ? 'Executando...' : 'Executar'}
          </Button>
          {results[a.id] != null && (
            <div style={{ marginTop: 12, fontSize: 13, color: results[a.id]!.affected >= 0 ? T.success : T.danger }}>
              {results[a.id]!.affected >= 0 ? `${results[a.id]!.affected} conversas afetadas` : 'Erro ao executar'}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}

// ── Tokens Tab ──
function TokensTab() {
  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [rotating, setRotating] = useState(false);
  const [rotateResult, setRotateResult] = useState('');

  useEffect(() => {
    api.get('/admin/chat/tokens').then((res: any) => {
      setData(res?.data || res);
    }).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const rotateTokens = async () => {
    if (!confirm('Rotacionar todos os tokens sem encryption? Tokens antigos serão revogados.')) return;
    setRotating(true);
    setRotateResult('');
    try {
      const res: any = await api.post('/admin/chat/tokens/rotate', {});
      const d = res?.data || res;
      setRotateResult(d?.message || `${d?.rotated || 0} tokens rotacionados`);
      // Recarregar dados
      const fresh: any = await api.get('/admin/chat/tokens');
      setData(fresh?.data || fresh);
    } catch { setRotateResult('Erro ao rotacionar tokens'); }
    finally { setRotating(false); }
  };

  if (loading) return <div style={{ padding: 16 }}><SkeletonBar width="50%" height={14} style={{ marginBottom: 8 }} /><SkeletonBar width="30%" height={14} /></div>;

  const customers: any[] = data?.customers || [];

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>
      {/* Stats cards */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 16 }}>
        <div style={s.metricCard}>
          <div style={{ fontSize: 12, color: T.textSecondary, fontWeight: 500, marginBottom: 8 }}>Total Tokens Ativos</div>
          <div style={{ fontSize: 28, fontWeight: 700, color: T.primary }}>{data?.total_tokens || 0}</div>
        </div>
        <div style={s.metricCard}>
          <div style={{ fontSize: 12, color: T.textSecondary, fontWeight: 500, marginBottom: 8 }}>Sem Encryption</div>
          <div style={{ fontSize: 28, fontWeight: 700, color: data?.unencrypted_tokens ? T.danger : T.success }}>{data?.unencrypted_tokens || 0}</div>
        </div>
        <div style={s.metricCard}>
          <div style={{ fontSize: 12, color: T.textSecondary, fontWeight: 500, marginBottom: 8 }}>Saldo Total Wallets</div>
          <div style={{ fontSize: 28, fontWeight: 700, color: T.success }}>${(data?.total_wallet_balance || 0).toFixed(2)}</div>
        </div>
      </div>

      {/* Botão rotacionar */}
      <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
        <Button variant={data?.unencrypted_tokens ? 'danger' : 'primary'} size="sm" onClick={rotateTokens} disabled={rotating}>
          {rotating ? 'Rotacionando...' : 'Rotacionar tokens sem encryption'}
        </Button>
        {rotateResult && <span style={{ fontSize: 13, color: rotateResult.includes('Erro') ? T.danger : T.success }}>{rotateResult}</span>}
      </div>

      {data?.message && (
        <div style={{ padding: '12px 16px', background: T.warningBg, border: `1px solid ${T.warningBgStrong}`, borderRadius: 8, fontSize: 13, color: T.warning }}>
          {data.message}
        </div>
      )}

      {/* Tabela de customers */}
      <div style={{ ...s.card, padding: 0, overflow: 'auto' }}>
        <table style={s.table}>
          <thead>
            <tr>
              <th style={s.th}>Customer</th>
              <th style={s.th}>Email</th>
              <th style={s.th}>Saldo Wallet</th>
              <th style={s.th}>Custo Chat</th>
              <th style={s.th}>Tokens</th>
              <th style={s.th}>Sem Encrypt</th>
              <th style={s.th}>Último Uso</th>
              <th style={s.th}>Status</th>
            </tr>
          </thead>
          <tbody>
            {customers.length === 0 ? (
              <tr><td colSpan={8} style={{ ...s.td, textAlign: 'center', color: T.textMuted }}>Nenhum token encontrado</td></tr>
            ) : customers.map((c: any, i: number) => (
              <tr key={c.customer_id} style={{ background: c.low_balance ? T.dangerBg : i % 2 === 0 ? 'transparent' : T.bgSubtle }}>
                <td style={{ ...s.td, fontSize: 12 }}>{c.name || c.customer_id?.slice(0, 8)}</td>
                <td style={{ ...s.td, fontSize: 12 }}>{c.email || '-'}</td>
                <td style={{ ...s.td, fontSize: 12, color: c.low_balance ? T.danger : T.text, fontWeight: c.low_balance ? 700 : 400 }}>
                  ${(c.wallet_balance || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </td>
                <td style={{ ...s.td, fontSize: 12 }}>${(c.chat_hub_cost || 0).toFixed(4)}</td>
                <td style={s.td}>{c.token_count || 0}</td>
                <td style={{ ...s.td, color: c.unencrypted_count > 0 ? T.danger : T.success }}>{c.unencrypted_count || 0}</td>
                <td style={{ ...s.td, fontSize: 11, color: T.textMuted }}>{c.last_used ? new Date(c.last_used).toLocaleDateString('pt-BR') : '-'}</td>
                <td style={s.td}>
                  <span style={{ padding: '2px 8px', borderRadius: 6, fontSize: 11, fontWeight: 600, background: c.low_balance ? T.dangerBg : T.successBg, color: c.low_balance ? T.danger : T.success }}>
                    {c.low_balance ? 'Saldo baixo' : 'OK'}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

// ── Página principal ──
export function AdminChatHub(_props: { path?: string }) {
  const [activeTab, setActiveTab] = useState('dashboard');
  const [complianceBadge, setComplianceBadge] = useState(0);

  // Buscar contagem de compliance pendentes para badge
  useEffect(() => {
    api.get('/admin/chat/compliance?limit=1').then((res: any) => {
      const d = res?.data || res;
      setComplianceBadge(d?.pending_count || 0);
    }).catch(() => {});
  }, [activeTab]);

  return (
    <div style={s.page}>
      <h1 style={s.title}>Chat — Administração</h1>

      {/* Tabs */}
      <div style={s.tabBar}>
        {TABS.map(tab => (
          <div key={tab.id} style={s.tab(activeTab === tab.id)} onClick={() => setActiveTab(tab.id)}>
            {tab.icon} {tab.label}
            {tab.id === 'compliance' && complianceBadge > 0 && (
              <span style={{ background: T.danger, color: T.text, fontSize: 10, fontWeight: 700, padding: '1px 6px', borderRadius: 10, marginLeft: 4 }}>{complianceBadge}</span>
            )}
          </div>
        ))}
      </div>

      {/* Conteúdo */}
      {activeTab === 'dashboard' && <DashboardTab />}
      {activeTab === 'conversations' && <ConversationsTab />}
      {activeTab === 'config' && <ConfigTab />}
      {activeTab === 'users' && <UsersTab />}
      {activeTab === 'compliance' && <ComplianceTab />}
      {activeTab === 'analytics' && <AnalyticsTab />}
      {activeTab === 'cleanup' && <CleanupTab />}
      {activeTab === 'tokens' && <TokensTab />}
    </div>
  );
}
